module.exports = __webpack_public_path__ + "assets/d4127401b138261fc9088749fc8cd4aa.jpg";